import type { Locale } from 'antd/es/locale'

import korea from 'antd/es/locale/ko_KR'
import english from 'antd/es/locale/en_US'
import french from 'antd/es/locale/fr_FR'
import russian from 'antd/es/locale/ru_RU'
import chinese from 'antd/es/locale/zh_CN'
import japanese from 'antd/es/locale/ja_JP'

export type LocaleKey = 'ko-KR' | 'en-US' | 'fr-FR' | 'ru-RU' | 'zh-CN' | 'ja-JP'

const locales: Record<LocaleKey, Locale> = {
  'ko-KR': korea,
  'en-US': english,
  'fr-FR': french,
  'ru-RU': russian,
  'zh-CN': chinese,
  'ja-JP': japanese,
}

export const antdLocales = locales

export function isAvailable(locale: string): boolean {
  return locales[locale as LocaleKey] != null
}

export function getAvailableLocale(localeStr: string): LocaleKey {
  const str = localeStr
  const val = Object.keys(locales).find((locale) => {
    return locale.indexOf(str) === 0
  })

  return (val as LocaleKey) || 'en-US'
}
